import React from 'react';
import { SpeedDial, SpeedDialAction, SpeedDialIcon } from '@mui/material';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import EmailIcon from '@mui/icons-material/Email';
import InstagramIcon from '@mui/icons-material/Instagram';
import GithubIcon from '@mui/icons-material/GitHub';

const actions = [
    { icon: <EmailIcon className='social-media-icons email-icon' />, name: 'Email', link: 'mailto:sabsidhu@hotmail.com' },
    { icon: <LinkedInIcon className='social-media-icons linkedin-icon' />, name: 'LinkedIn', link: 'https://www.linkedin.com/in/sahibsidhu/' },
    { icon: <InstagramIcon className='social-media-icons insta-icon' />, name: 'Instagram', link: 'https://www.instagram.com/sahibsidhu18/' },
    { icon: <GithubIcon className='social-media-icons github-icon' />, name: 'GitHub', link: 'https://github.com/sahibsidhu' },
];

const SpeedDialComponent = () => {
  const [open, setOpen] = React.useState(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleClick = (action) => {
    window.open(action.link, '_blank'); 
    handleClose();
  };

  return (
    <SpeedDial
      ariaLabel="SpeedDial example"
      sx={{ position: 'fixed', bottom: 16, right: 16 }}
      icon={<SpeedDialIcon />}
      onClose={handleClose}
      onOpen={handleOpen}
      open={open}
    >
      {actions.map((action) => (
        <SpeedDialAction
          key={action.name}
          icon={action.icon}
          tooltipTitle={action.name}
          onClick={() => handleClick(action)}
        />
      ))}
    </SpeedDial>
  );
};

export default SpeedDialComponent;
